// @ts-nocheck
import { takeLatest, all, call, put } from 'redux-saga/effects';
import * as types from 'appRedux/actions/dashboard';
// import { SHOW_FULLSCREEN_LOADER, HIDE_FULLSCREEN_LOADER } from 'appRedux/actions/loader';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import getQueryParams from 'utils/getQueryParams';

const urls = [
  'dashboard-project-details',
  'project-status',
  'v1.1/project/project_dashboard', // <--- budget status
  'v1.1/project/project_dashboard_chart_widget', // <--- budget total
  'contact-value-api',
  'project-cost',
  'project-variations',
  // 'project-table',
  'project-cash-flow',
  'project-revenue',
  'dashboard-layout',
];

function* getDashboardReports(action) {
  try {
    const token = localStorage.getItem('token');
    const { payload } = action;
    const query = getQueryParams(payload);
    const layoutQuery = getQueryParams({
      project_id: payload.project_id,
    });

    const [
      basicInfo,
      projectStatus,
      budgetStatus,
      budgetTotal,
      contractValue,
      costs,
      variations,
      cashFlow,
      revenue,
      preference,
    ] = yield all(
      urls.map((url) =>
        call(
          services.fetchGetApi,
          `${API_URI}/${url}/?${
            url === 'dashboard-layout' ? layoutQuery : query
          }`,
          token,
        ),
      ),
    );

    yield put({
      type: types.SET_PROJECT_BASIC_INFO,
      payload: basicInfo,
    });
    yield put({
      type: types.SET_PROJECT_STATUS,
      payload: projectStatus,
    });
    yield put({
      type: types.SET_BUDGET_STATUS,
      payload: budgetStatus,
    });
    yield put({
      type: types.SET_BUDGET_TOTAL,
      payload: budgetTotal,
    });
    yield put({
      type: types.SET_CONTRACT_VALUE,
      payload: contractValue,
    });
    yield put({
      type: types.SET_PROJECT_COST,
      payload: costs,
    });

    yield put({
      type: types.SET_PROJECT_VARIATIONS,
      payload: variations,
    });

    yield put({
      type: types.SET_PROJECT_CASH_FLOW,
      payload: cashFlow,
    });

    yield put({
      type: types.SET_PROJECT_REVENUE,
      payload: revenue,
    });

    // yield put({
    //   type: types.SET_USER_PREFERENCE,
    //   payload: preference,
    // });

    yield put({
      type: types.GET_DASHBOARD_REPORTS_SUCCESS,
    });
  } catch (err) {
    yield put({ type: types.GET_DASHBOARD_REPORTS_FAILURE });
  }
}

function* addUserPreference(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  yield call(
    services.fetchPostApi,
    `${API_URI}/dashboard-layout/`,
    payload,
    token,
  );
}

function* updateUserPreference(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  yield call(
    services.fetchPutApi,
    `${API_URI}/dashboard-layout/${payload.id}/`,
    payload,
    token,
  );
}

function* dashboardWatcher() {
  yield takeLatest(types.GET_DASHBOARD_REPORTS_REQUEST, getDashboardReports);
  yield takeLatest(types.ADD_USER_PREFERENCE_REQUEST, addUserPreference);
  yield takeLatest(types.UPDATE_USER_PREFERENCE_REQUEST, updateUserPreference);
}

export default dashboardWatcher;
